import apiClient from './apiClient';

// Operaciones destructivas o irreversibles sobre trámites y clientes. Todas piden confirmación
// explícita del lado del backend además del gateo por rol, así que el frontend no es la única
// barrera: acá solo se arma el pedido y se muestra el preview.

// ---------------------------------------------------------------- cambio de tipo

/** Tipos entre los que se puede convertir un trámite (RTI y ART quedan afuera). */
export const getTiposMigrables = async () => {
    const { data } = await apiClient.get('/tramites/cambiar-tipo/tipos');
    return Array.isArray(data) ? data : [];
};

/** Qué se conserva, qué se descarta y qué datos hay que completar. No modifica nada. */
export const previsualizarCambioTipo = async (idTramite, tipoDestino) => {
    const { data } = await apiClient.get(`/tramites/${idTramite}/cambiar-tipo/preview`, {
        params: { tipoDestino },
    });
    return data;
};

/** `camposDestino` son los que el preview devolvió en `camposRequeridos`. */
export const cambiarTipoTramite = async (idTramite, { tipoDestino, motivo, camposDestino }) => {
    await apiClient.post(`/tramites/${idTramite}/cambiar-tipo`, {
        tipoDestino,
        motivo,
        camposDestino: camposDestino || {},
    });
};

// ------------------------------------------------------------- borrado definitivo

export const previsualizarEliminacionTramite = async (idTramite) => {
    const { data } = await apiClient.get(`/admin/eliminacion/tramite/${idTramite}/preview`);
    return data;
};

/** `confirmacion` tiene que ser exactamente `confirmacionRequerida` del preview. */
export const eliminarTramiteDefinitivo = async (idTramite, { motivo, confirmacion }) => {
    await apiClient.delete(`/admin/eliminacion/tramite/${idTramite}`, {
        data: { motivo, confirmacion },
    });
};

export const previsualizarEliminacionCliente = async (cuil) => {
    const { data } = await apiClient.get(`/admin/eliminacion/cliente/${cuil}/preview`);
    return data;
};

export const eliminarClienteDefinitivo = async (cuil, { motivo, confirmacion }) => {
    await apiClient.delete(`/admin/eliminacion/cliente/${cuil}`, {
        data: { motivo, confirmacion },
    });
};
